import { tv } from "tailwind-variants";
import { cn } from "../../utils/class-names";
import { getProtocol, ProtocolKey, Usd } from "@silo/types";
import { asFullUsd } from "@silo/utils";
import { ChevronRightIcon } from "../../icons";
import { buttonV2 } from "../button-v2";

export const trigger = tv({
  base: buttonV2({ variant: "secondary", className: "md:flex sm:w-fit" }),
});

interface TriggerContentProps {
  className?: string;
  protocolKey: ProtocolKey;
  totalRewardsUsd: Usd;
}

export function TriggerContent({
  className,
  protocolKey,
  totalRewardsUsd,
}: TriggerContentProps): JSX.Element {
  const protocol = getProtocol(protocolKey);

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2.5 text-sm",
        className
      )}
    >
      <div className="flex flex-col sm:flex-row items-start gap-2.5">
        <div className="block sm:hidden text-shale-200">
          Rewards on {protocol.label}
        </div>

        <div className="hidden sm:block text-shale-200">
          {protocol.label} rewards
        </div>

        <div className="font-medium text-white">
          {asFullUsd(totalRewardsUsd)}
        </div>
      </div>

      <ChevronRightIcon className="w-7 h-7 md:hidden" />
    </div>
  );
}
